module.exports = __webpack_public_path__ + "img/makarova.c1e1309f.jpg";